import React from 'react';
import ContentFooter from './ContentFooter';
import Social from './Social';

const AppFooter = () => (
  <>
    <ContentFooter />
    <Social />
  </>
);

export default AppFooter
